<template>
	<div v-if="Array.isArray(images)" class="slider">
		<div class="image-liste">
			<div class="image-wrapper" v-for="(image, i) in images" :key="i">
				<img :src="`/image/realisation/${image}`" class="img-fluid" />
			</div>
		</div>
		<div class="slider-arrow-wrapper">
			<img src="/image/fleche-gauche.png" class="arrow arrow-left" v-on:click="slidingLeft" />
			<img src="/image/fleche-droite.png" class="arrow arrow-right" v-on:click="slidingRight" />
		</div>
	</div>
	<div v-else class="image-wrapper">
		<img :src="`/image/realisation/${images}`" class="img-fluid" />
	</div>
</template>

<script>
export default {
	name: "Slider",
	props: ["images"],
	data() {
		return {
			slide: 0,
			slides: null
		};
	},
	methods: {
		sliding: function() {
			for (let element of this.slides) {
				// prettier-ignore
				element.style.webkitTransform = `translateX(${-100 * this.slide}%)`;
				// prettier-ignore
				element.style.msTransform = `translate-x(${-100 * this.slide}%)`;
				// prettier-ignore
				element.style.transform = `translateX(${-100 * this.slide}%)`;
			}
		},
		slidingLeft: function() {
			if (!this.slides) {
				this.slides = document.getElementsByClassName("image-wrapper");
			}
			if (this.slide) {
				this.slide = this.slide - 1;
			} else {
				this.slide = this.slides.length - 1;
			}
			this.sliding();
		},
		slidingRight: function() {
			if (!this.slides) {
				this.slides = document.getElementsByClassName("image-wrapper");
			}
			if (this.slide < this.slides.length - 1) {
				this.slide = this.slide + 1; //une opération de moins que ++
			} else {
				this.slide = 0;
			}
			this.sliding();
		}
	}
};
</script>
